<!-- <svg width="40" height="40" viewBox="0 0 100 100">
	<circle cx="50" cy="50" r="10" fill="#ff0000">
		<animate attributeName="r" from="10" to="40" dur="1.5s" repeatCount="indefinite" />
		<animate attributeName="opacity" from="1" to="0" dur="1.5s" repeatCount="indefinite" />
	</circle>
	<circle cx="50" cy="50" r="10" fill="#ff0000" />
</svg> -->
<svg [attr.width]="size" [attr.height]="size" viewBox="0 0 100 100">
	<circle cx="50" cy="50" r="20" fill="#ff0000">
		<animate attributeName="r" from="20" to="60" dur="1.5s" repeatCount="indefinite" />
		<animate attributeName="opacity" from="1" to="0" dur="1.5s" repeatCount="indefinite" />
	</circle>
	<circle cx="50" cy="50" r="20" fill="#ff0000" />
</svg>